export enum LinksNdiSp {
	EXAMS_SP = 'https://www.notrelabs.com.br/resultados-acesso',
	EXAMS_RJ = 'https://resultadoexame.hapvida.com.br/resultado-exame/autenticacao.xhtml',
	NEWS = 'https://www.gndi.com.br/noticias/beneficiarios-com-planos-cancelados',
	PORTAL = 'https://www.gndi.com.br/',
	INCOME_TAX_AND_COPART = 'https://www.gndi.com.br/beneficiario',
	LGPD = 'https://www.gndi.com.br/portal-da-privacidade',
}
